import { SortableElement } from "react-sortable-hoc";

import Author from "./Author";

export default SortableElement(Author);
